import * as types from './navbar.actionType';
import Immutable from 'seamless-immutable';
import sessionUtils from '@common/helpers/sessionStorage.utils';

const initialState = Immutable({
  menu: [],
  menuSearch: [],
  systems: [],
  user: {},
  favorite: [],
  favoritosSelecionados: [],
  icon: undefined,
  totalNotification: undefined,
  isLoading: undefined,
  pagesNotification: [],
  gridNotification: [],
  gridRefresh: false,
  numberNotification: undefined,
  menuCollapse: {
    toggleMenu: false,
    locked: true,
  },
  about: {
    Sistema: "",
    UltimaAtualizacao: "",
    VersaoApi: "",
    VersaoWebapp: "",
    Servidor: "",
    BancoDados: ""
}
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.TOGGLE_MENU:
      return state.merge({ menuCollapse: { toggleMenu: !state.menuCollapse.toggleMenu } });

    case types.LOCK_MENU:
      return state.merge({
        menuCollapse: { locked: !state.menuCollapse.locked, toggleMenu: !state.menuCollapse.toggleMenu },
      });

    case types.SET_MENU:
      return state.merge({
        menu: action.payload,
      });

    case types.SET_MENUSEARCH:
      return state.merge({
        menuSearch: action.payload,
      });

    case types.SET_SYSTEMS:
      return state.merge({
        systems: action.payload,
      });

    case types.SET_LASTACCESS:
      return state.merge({
        user: action.payload,
      });

    case types.SET_FAVORITOS:
      return state.merge({
        icon: action.payload,
      });

    case types.SET_FAVORITOS_SELECIONADOS:
      return state.merge({
        favoritosSelecionados: action.payload,
      });

    case types.SET_PAGES_NOTIFICATION:
      return state.merge({ pagesNotification: action.payload });

    case types.SET_NOTIFICATION:
      return state.merge({ ...state, ...action.payload });

    case types.SET_READPAGES_NOTIFICATION:
      return state.merge({
        pagesNotification: [...state.pagesNotification, ...action.payload],
      });
    case types.SET_NEW_NOTIFICATION:
      let pages = Immutable.asMutable(state.pagesNotification);
      if (action.payload && action.payload.IdSistema == sessionUtils.getSistema()) pages.splice(0, 0, action.payload);
      return state.merge({
        pagesNotification: pages,
      });
    case types.UPDATE_INFO_ABOUT:
      let about = { ...action.payload };
      if (window.release_info != undefined) {
        about.UltimaAtualizacao = window.release_info.ultimaAtualizacao;
        about.VersaoApi = window.release_info.versaoApi;
        about.VersaoWebapp = window.release_info.versaoWebapp;
      }  
      return state.merge({ about });
    default:
      return state;
  }
}
